/**
 * Controller for the company settings in the settings page.
 */
angular
    .module('cfn')
    .controller('companySettingsController', companySettingsController);

companySettingsController.$inject = [
  '$scope',
  '$rootScope',
  '$log',
  '$q',
  '$timeout',
  '$http',
  '$window',
  'UpdateService',
  'CompanySettings',
  'UserSettings',
  'i18nFilter',
  'companyFinanceService',
  'CfnDialogService',
  'userSettingsService',
  'CountryService',
  'ShopPaymentService',
  'shopPaymentDialogService',
  'ShopVatRegistrationNumberService'
];
function companySettingsController(
    $scope,
    $rootScope,
    $log,
    $q,
    $timeout,
    $http,
    $window,
    UpdateService,
    CompanySettings,
    UserSettings,
    i18nFilter,
    companyFinanceService,
    CfnDialogService,
    userSettingsService,
    CountryService,
    ShopPaymentService,
    shopPaymentDialogService,
    ShopVatRegistrationNumberService
) {
    var controller = this;
    var unWatchSettings;

    $scope.ctrl = controller;
    $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
    $scope.ctrl.showPaymentMethodDetails = false;
    $scope.ctrl.showVatRegistrationNumber = false;

    function init() {
      controller.rights = app.credentials.rights;
      controller.SaveTimeout = 500;
      controller.credentials = app.credentials;

      // TODO: make this generic!
      controller.modalShown = false;
      // TODO: make this generic!
      controller.toggleModal = function() {
        controller.modalShown = !controller.modalShown;
      };

      CompanySettings.get({}, function(companySettings) {
        controller.companySettings = companySettings;
        if (
          companySettings.messagingContext &&
          companySettings.messagingContext.messages &&
          companySettings.messagingContext.messages.length > 0
        ) {
          angular.forEach(companySettings.messagingContext.messages, function(
            detail,
            value
          ) {
            $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.' + detail.key, detail.value),
              'error'
            );
          });
        }
        if (isVatNeeded()) {
          $scope.ctrl.showVatRegistrationNumber = true;
          setVatNumber();
        }
      });

      UserSettings.get({}, function(userSettings) {
        controller.userSettings = userSettings;
        unWatchSettings = watchSettings();
      });

      CountryService.getCountries().then(function(response) {
        var all = CountryService.sortCountries(response.data);
        var filtered = [];
        if (app.credentials.company.shopCountry) {
          for (var j = 0; j < all.length; j++) {
            if (all[j].shopCountry) {
              filtered.push(all[j]);
            }
          }
        } else {
          filtered = all;
        }

        $scope.countries = filtered;
      });

      ShopPaymentService.getActivePaymentMethod().then(function(response) {
        if (
          response == null ||
          response.data == null ||
          response.data.value == null
        ) {
          $scope.ctrl.showPaymentMethodDetails = false;
        } else {
          $scope.ctrl.showPaymentMethodDetails = true;
          $scope.ctrl.activePayment = response.data.value;
          if (
            $scope.ctrl.activePayment.paymentProviderId ===
            'com.farmnet365.payment.evo' && $scope.ctrl.activePayment.paymentDetails
          ) {
            $scope.ctrl.activePayment.paymentDetails.details[
              'fe.payment.creditcard.expiresYear'
            ] = $scope.getPaymentDetailByCode(
              $scope.ctrl.activePayment.paymentDetails.details,
              'fe.payment.creditcard.expiry',
              0,
              4
            );
            $scope.ctrl.activePayment.paymentDetails.details[
              'fe.payment.creditcard.expiresMonth'
            ] = $scope.getPaymentDetailByCode(
              $scope.ctrl.activePayment.paymentDetails.details,
              'fe.payment.creditcard.expiry',
              4,
              null
            );
          }
        }
      });
    }

    $scope.$on('userSettingsAccountOwnerEmailChanged', function(event, args) {
      controller.userSettings.contactEmail = args.newEmail;
    });

    let isVatNeeded = () => {
      const countriesWithoutVatNumber = ['CHE'];
      return !~countriesWithoutVatNumber.indexOf(
          userSettingsService.getIsoCountryEnum()
      )
    }

    let setVatNumber = () => {
      ShopVatRegistrationNumberService.getVatRegistrationNumber()
          .then(function(result) {
            if (result.data.value) {
              $scope.ctrl.vatRegistrationNumber =
                  result.data.value.registrationNumber;
            }
          })
          .catch(function(error) {
            // $scope.model.ignoreVatRegistrationNumber = true;
            // TODO: error handling
            $rootScope.alertController.addTemporaryAlert(
                i18nFilter('fe.shop.vatregistrationnumber.get.error'),
                'error'
            );
          });
    }

    $scope.getPaymentDetailByCode = function(paymentDetails, code, from, to) {
      var retValue = '';
      angular.forEach(paymentDetails, function(detail, value) {
        if (code === value) {
          retValue = detail;
        }
      });

      if (from !== null && to !== null) {
        return retValue.substring(from, to);
      } else if (from !== null) {
        return retValue.substring(from);
      }
      return retValue;
    };

    $scope.showBankAccountModal = function() {
      shopPaymentDialogService
        .open(controller.companySettings)
        .then(function(paymentData) {
          // TODO: webpack file ending
          if (
            paymentData &&
            paymentData['paymentProviderId'] === 'com.farmnet365.payment.iban'
          ) {
            controller.activePayment.paymentProviderId =
              paymentData['paymentProviderId'];
            controller.companySettings.bankAccount =
              paymentData['fe.admin.settings.bankAccount'];
            controller.companySettings.bankHolder =
              paymentData['fe.admin.settings.bankHolder'];
            controller.activePayment.paymentDetails.details[
              'fe.admin.settings.bankAccount'
            ] =
              paymentData['fe.admin.settings.bankAccount'];
            controller.activePayment.paymentDetails.details[
              'fe.admin.settings.bankHolder'
            ] =
              paymentData['fe.admin.settings.bankHolder'];
          } else if (
            paymentData &&
            paymentData['paymentProviderId'] === 'com.farmnet365.payment.evo'
          ) {
            controller.companySettings.bankAccount = null;
            controller.companySettings.bankHolder = null;
            controller.activePayment.paymentProviderId =
              paymentData['paymentProviderId'];
            controller.activePayment.paymentDetails.details[
              'fe.payment.creditcard.brand'
            ] =
              paymentData['fe.payment.creditcard.brand'];
            controller.activePayment.paymentDetails.details[
              'fe.payment.creditcard.pkn'
            ] =
              paymentData['fe.payment.creditcard.pkn'];
            controller.activePayment.paymentDetails.details[
              'fe.payment.creditcard.expiry'
            ] =
              paymentData['fe.payment.creditcard.expiry'];
            controller.activePayment.paymentDetails.details[
              'fe.payment.creditcard.expiresYear'
            ] = $scope.getPaymentDetailByCode(
              controller.activePayment.paymentDetails.details,
              'fe.payment.creditcard.expiry',
              0,
              4
            );
            controller.activePayment.paymentDetails.details[
              'fe.payment.creditcard.expiresMonth'
            ] = $scope.getPaymentDetailByCode(
              controller.activePayment.paymentDetails.details,
              'fe.payment.creditcard.expiry',
              4,
              null
            );
          } else if (
              paymentData &&
              paymentData['paymentProviderId'] === 'com.farmnet365.payment.invoice'
          ) {
              controller.companySettings.bankAccount = null;
              controller.companySettings.bankHolder = null;
              controller.activePayment.paymentProviderId =
                  paymentData['paymentProviderId'];
          }
        });
    };

    // handle modal close event on `vatRegistrationNumber` validation errors
    $scope.$watch('ctrl.modalShown', function() {
      if (
        controller.modalShown === false &&
        controller.vatRegistrationNumberErrorKey
      ) {
        controller.vatRegistrationNumberErrorKey = null;
        controller.vatRegistrationNumber = null;
      }
    });

    $scope.saveVatRegistrationNumber = function() {
      var registrationNumber = controller.vatRegistrationNumber
        ? controller.vatRegistrationNumber
        : null;
      ShopVatRegistrationNumberService.putVatRegistrationNumber(
        controller.companySettings.businessAddress.country,
        registrationNumber
      )
        .then(function(response) {
          if (response.data.validationResult.valid === false) {
            // front-end error handling for vat validation service
            switch (response.data.validationResult.errorCode) {
              case 'TECHNICAL_ERROR':
              case 'SERVICE_UNAVAILABLE':
                controller.vatRegistrationNumberErrorKey =
                  'fe.admin.settings.vatregistrationnumber.validation.error.technicalerror';
                break;
              case 'INVALID_NUMBER':
                controller.vatRegistrationNumberErrorKey =
                  'fe.admin.settings.vatregistrationnumber.validation.error.invalidnumber';
                break;
              default:
                controller.vatRegistrationNumberErrorKey =
                  response.data.validationResult.statusMessages[0].textMessage.messageKey;
                break;
            }
          } else {
            controller.modalShown = false; // TODO: make this generic!
            controller.vatRegistrationNumberErrorKey = null;
            $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.common.savedMsg')
            );
          }
        })
        .catch(function(error) {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.admin.settings.vatregistrationnumber.validation.error.technicalerror'
            ),
            'error'
          );
        });
    };

    // CFNPOC-5439: Don't show 'Firma' as an option
    $scope.addressFormAnredeEnumOptions = $rootScope.enums.AddressFormEnum.options.filter(
      function(option) {
        return option !== 'FIRM';
      }
    );

    $scope.changeBusinessAddressCountry = function() {
      var savedVatRegistrationNumber = controller.vatRegistrationNumber;

      if (savedVatRegistrationNumber) {
        var unwatchSaving = $scope.$watch('saving', function(
          newSavingValue,
          oldSavingValue
        ) {
          if (newSavingValue === false && oldSavingValue === true) {
            // during the GET-request the backend compares country and vatRegistrationNumber,
            // if they do not fit together, the vatregistrationNumber will be deleted and the GET-response returns NULL
            ShopVatRegistrationNumberService.getVatRegistrationNumber()
              .then(function(result) {
                var title = i18nFilter('fe.common.notice', '');
                var message = i18nFilter(
                  'fe.admin.settings.notice.countryChanged.dialog.text',
                  ''
                );

                $scope.ctrl.vatRegistrationNumber = result.data.value;

                CfnDialogService.showMessage(title, message, '');
              })
              .catch(function(error) {
                return $q.reject(error);
              });
            unwatchSaving();
          }
        });
      }
    };

    controller.applyFinanceData = function() {
      // TODO remove vat rate logic
      var oldVatRate = companyFinanceService.getVatRate();
      var newVatRate = controller.companySettings.vatRate;
      var oldCurrency = companyFinanceService.getCurrencyUnit();
      var newCurrency = controller.companySettings.currencyUnit;
      if (oldVatRate !== newVatRate || oldCurrency !== newCurrency) {
        var title = i18nFilter('fe.common.notice', 'Hinweis'),
          message = i18nFilter(
            'fe.admin.settings.notice.verifyprices.dialog.text',
            ''
          );
        CfnDialogService.showMessage(title, message, '');
      }
      companyFinanceService.setVatRate(newVatRate);

      companyFinanceService.setCurrencyUnit(newCurrency);
    };

    // save part
    var saveTimeout = null;
    var lastCompanySettings = null;
    var lastCompanySettingsString = null;

    controller.setSavedState = function(companySettings) {
      var hasErrors = controller.checkBEValidationChanges();
      lastCompanySettings = companySettings;
      lastCompanySettingsString = JSON.stringify(companySettings);
      return hasErrors;
    };

    controller.doSave = function(settings) {
      if ($scope.saving) {
        // prevent if already saving
        console.debug('save canceled', controller.companySettings);
        // try save again after some time if $scope.saving allows
        if (saveTimeout != null) {
          $timeout.cancel(saveTimeout);
        }
        saveTimeout = $timeout(function() {
          controller.doSave(controller.companySettings);
        }, controller.SaveTimeout);
        return;
      }

      $scope.saving = true;
      // NOTE: `settings/settings/` autosave rest call
      $http
        .put('/365FarmNet/rest/settings/settings/', settings)
        .then(
          function(response) {
            var data = response.data;
            // update data from result.
            userSettingsService.setAreaUnitEnum(data.areaUnit);
            controller.companySettings.messagingContext = data.messagingContext;
            var hasErrors = controller.setSavedState(
              controller.companySettings
            );
            if (!hasErrors) {
              $rootScope.alertController.addTemporaryAlert(
                i18nFilter('fe.common.savedMsg', 'Änderungen gespeichert')
              );
            }
            controller.applyFinanceData();
          },
          function(response) {
            var data = response.data;
            if (data) {
              unWatchSettings();
              controller.companySettings = data.errorSettings;
              lastCompanySettingsString = JSON.stringify(
                controller.companySettings
              );
              unWatchSettings = watchSettings();
            }
          }
        )
        .finally(function() {
          $scope.saving = false;
        });
    };

    // @DEPRECATED CFNPOC-24277 ON 2017.08.29
    /**
     * Used to calculate a property that indicates if validation is required for the billing address.
     * @returns {*|boolean} true if at least one of the fields of the billing address is a string.
     */
    function billingAddressHasValue(companySettings) {
      var billingAddress = companySettings.billingAddress;
      return (
        angular.isDefined(billingAddress) &&
        (angular.isString(billingAddress.street) ||
          angular.isString(billingAddress.houseNumber) ||
          angular.isString(billingAddress.district) ||
          angular.isString(billingAddress.zip) ||
          angular.isString(billingAddress.city) ||
          angular.isString(billingAddress.country) ||
          angular.isString(companySettings.firstNameBilling) ||
          angular.isString(companySettings.nameBilling) ||
          angular.isString(companySettings.anredeBilling) ||
          angular.isString(billingAddress.companyName))
      );
    }
    // @DEPRECATED CFNPOC-24277 /END

    function watchSettings() {
      return $scope.$watch(
        'ctrl.companySettings',
        function() {
          console.debug('watch company settings');

          var companySettings = controller.companySettings;
          controller.billingAddressHasValue =
            companySettings && billingAddressHasValue(companySettings); // @DEPRECATED CFNPOC-24277 ON 2017.08.29 /END
          var companySettingsString = JSON.stringify(companySettings);
          var isSettingsNotLoaded =
            companySettings == null || companySettings === undefined;

          if (isSettingsNotLoaded && lastCompanySettings != null) {
            if (saveTimeout != null) {
              $timeout.cancel(saveTimeout);
              saveTimeout = null;

              controller.doSave(lastCompanySettings);
              lastCompanySettingsString = null;
            }
            lastCompanySettings = null;
            return;
          }
          // skip initial change
          var isFirstWatch = lastCompanySettings == null;

          if (isFirstWatch) {
            lastCompanySettings = companySettings;
            return;
          }
          // only save if the form actually is dirty AND VALID
          var isSettingsDirty =
            lastCompanySettingsString !== companySettingsString;
          $timeout(function() {
            // wait a digest cycle for triggered validations, then check if everything is good
            if (isSettingsDirty && controller.companySettingsForm.$valid) {
              if (saveTimeout != null) {
                $timeout.cancel(saveTimeout);
              }
              saveTimeout = $timeout(function() {
                controller.doSave(companySettings);
                saveTimeout = null;
              }, controller.SaveTimeout);
            }
          });
          lastCompanySettings = companySettings;
          lastCompanySettingsString = companySettingsString;
        },
        true
      );
    }

    // end save part

    /**********************************start validation***********************************************/

    var vgi = {};

    vgi['bankHolder'] = '2';
    vgi['bankAccount'] = '2';
    vgi['bankBic'] = '2';
    vgi['bankBank'] = '2';

    var validationGroupInfo = vgi;
    var validationForm = $("form[name='companySettingsForm']");

    function getContentByKey(key) {
      var k = key;
      if (k.indexOf('__') !== -1) {
        k = k.substr(0, k.indexOf('__'));
      }
      var content = validationGroupInfo[k];
      return content;
    }

    controller.updateBEValidation = function() {
      var hasErrors = false;
      var tabErrors = {};
      controller.beValidationFields = {};
      if (
        controller.companySettings &&
        controller.companySettings.messagingContext
      ) {
        var context = controller.companySettings.messagingContext;
        for (var i in context.messages) {
          var msg = context.messages[i];
          if (!msg.key || msg.key === '') {
            controller.beValidationFields[msg.value] = true; // store already done validation
            if (msg.type === 'ERROR') {
              $rootScope.alertController.addTemporaryAlert(msg.value, 'error');
            } else {
              $rootScope.alertController.addTemporaryAlert(
                msg.value,
                'warning'
              );
            }
          }
          if ((msg.type === 'ERROR' || msg.type === 'WARNING') && msg.key) {
            var tab = getContentByKey(msg.key);
            if (!tab) {
              console.debug('Tab for ' + msg.key + ' not found');
            } else {
              if ($('#tabContent' + tab).is(':visible')) {
                controller.beValidationFields[msg.key] = true;
                if (msg.type === 'ERROR') {
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                  hasErrors = true;
                } else {
                  //TODO: Style for Warnings
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                }
              } else {
                if (!tabErrors[tab]) {
                  tabErrors[tab] = 0;
                }
                tabErrors[tab]++;
              }
            }
          }
        }
        for (var tabError in tabErrors) {
          var errorCount = tabErrors[tabError];
          $('#tabHeader' + tabError).validationEngine(
            'showPrompt',
            errorCount + ' Fehler',
            'error',
            undefined,
            true
          );
          $('#tabHeader' + tabError).off('click.cfn'); // remove old
          // handler
          $('#tabHeader' + tabError).on('click.cfn', function() {
            $('#tabHeader' + tabError).validationEngine('hide');
            hasErrors = controller.checkBEValidationChanges();
          });
        }
      }
      return hasErrors;
    };
    controller.checkBEValidationChanges = function() {
      var hasErrors = false;
      if (
        controller.companySettings &&
        controller.companySettings.messagingContext &&
        controller.beValidationFields
      ) {
        var oldFields = controller.beValidationFields;
        controller.beValidationFields = [];
        var context = controller.companySettings.messagingContext;
        for (var i in context.messages) {
          var msg = context.messages[i];
          if (!msg.key || msg.key === '') {
            controller.beValidationFields[msg.value] = true; // store already done validation
            if (!oldFields[msg.value]) {
              if (msg.type === 'ERROR') {
                $rootScope.alertController.addTemporaryAlert(
                  msg.value,
                  'error'
                );
              } else {
                $rootScope.alertController.addTemporaryAlert(
                  msg.value,
                  'warning'
                );
              }
            }
          }

          if ((msg.type === 'ERROR' || msg.type === 'WARNING') && msg.key) {
            // neues prompt !
            controller.beValidationFields[msg.key] = true;

            var tab = getContentByKey(msg.key);
            if (!tab) {
              console.debug('Tab for ' + msg.key + ' not found');
            } else {
              $log.debug('new prompt', msg.key);
              if ($('#tabContent' + tab).is(':visible')) {
                controller.beValidationFields[msg.key] = true;
                if (msg.type === 'ERROR') {
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                  hasErrors = true;
                } else {
                  //TODO: Style for Warnings
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                }
              }
            }
          }
        }
        for (var key in oldFields) {
          if (!controller.beValidationFields[key]) {
            try {
              $('#' + key).validationEngine('hide');
              $('.' + key + 'formError').remove();
            } catch (e) {
              $log.debug('error in closing ', e);
            }
          }
        }
      }
      return hasErrors;
    };
    controller.removeValidation = function() {
      validationForm.validationEngine('hideAll');
      validationForm.validationEngine('detach');
    };
    controller.updateValidation = function() {
      $log.debug('update validation');
      setTimeout(function() {
        validationForm.validationEngine('attach', {
          relative: true,
          scroll: false,
          promptPosition: 'topLeft'
        });
      }, 0);
      setTimeout(function() {
        // only validate if already has been saved

        if (controller.companySettings && controller.companySettings.id) {
          validationForm.validationEngine('validate');
          controller.updateBEValidation();
        }
      }, 1000);
    };

    setTimeout(function() {
      controller.updateValidation();
    }, 0);

    init();
};
